import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import StateProvider from './stateProvider';
import axios from 'axios';

import './App.css';
import './App.med.css';
import './App.large.css';

import Header from './components/header';
import Home from './components/home';
import SuggestedListings from './components/suggestedListings';
import About from './components/about';
import Login from './components/login';
import { Profile } from './components/profile';
import Applications from './components/applications';
import Resume from './components/resume';
import FormatSelector from './components/formatSelector';
import TrackApplication from './components/trackApplication';
import SignUp from './components/signup';
import ForgotPassword from './components/forgotPassword';
import PasswordReset from './components/passwordReset';
import Notifications from './components/notifications';
import { Popup } from './components/popup';
import { Subscription} from './components/subscription';
import Footer from './components/footer';
import  Company from './components/company';

function App() {

  const [csrfCookie, setCsrfCookie] = useState(false);

  // get csrf cookie upon site rendering
  useEffect(() => {
    axios.get('/api/get_csrf').then(() => {
      // allow site to render
      setCsrfCookie(true)
    });
  }, []);


  return (
    <>
      { csrfCookie == true ?
        <Router>
          <StateProvider>
            <Notifications/>
            <Popup/>
            <Header/>
            <Routes>
              <Route path="/" element={<Home/>}></Route>
              <Route path="/company" element={<Home/>}></Route>
              <Route path="/company/:companyName?" element={<Company/>}></Route>
              <Route path="/suggested/" element={<SuggestedListings/>}></Route>
              <Route path="/suggested/:pageNumber?" element={<SuggestedListings/>}></Route>
              <Route path="/suggested/:pageNumber?/:pPageSize?" element={<SuggestedListings/>}></Route>
              <Route path="/:role?" element={<Home/>}></Route>
              <Route path="/:pageNumber?/:pPageSize?/*" element={<Home/>}></Route>
              <Route path="/:role?/:pageNumber?/:pPageSize?/*" element={<Home/>}></Route>
              <Route path="/home/:pageNumber?/:pPageSize?/*" element={<Home/>}></Route>
              <Route path="/home/:role" element={<Home parameterType="role"/>}></Route>
              <Route path="/home/:role?/:pageNumber?/:pPageSize?/*" element={<Home/>}></Route>
              <Route path="/about" element={<About/>}></Route>
              <Route path="/trackApplication" element={<TrackApplication/>}></Route>
              <Route path="/applications" element={<Applications/>}></Route>
              <Route path="/applications/:applicationStatus?/:pageNumber?/:pPageSize?" element={<Applications/>}></Route>
              <Route path="/resume/selectDefault" element={<FormatSelector/>}></Route>
              <Route path="/resume/selectDefault/:appID" element={<FormatSelector/>}></Route>
              <Route path="/resume/:appID/:resumeFormat" element={<Resume/>}></Route>
              <Route path="/resume/:appID" element={<Resume/>}></Route>
              <Route path="/login/:loginParam?/:firstParam?/:secondParam?" element={<Login/>}></Route>
              <Route path="/signup" element={<SignUp/>}></Route>
              <Route path="/forgotPassword" element={<ForgotPassword/>}></Route>
              <Route path="/passwordReset/:userid?/:passwordResetID?" element={<PasswordReset/>}></Route>
              <Route path="/profile/:page" element={<Profile/>}></Route>
              <Route path="/subscription/:userid?/:sessionID?" element={<Subscription/>}></Route>
              <Route path="/*" element={<Home/>}></Route>
            </Routes>
            <Footer/>
          </StateProvider>
        </Router>
      : <div
          style={{height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}
        >
          <h1>WorkGuild.io</h1>
        </div>}
    </>
  );
}

export default App;
